import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { Card, CardContent, CardTitle } from './cardStyles'
import { getDocName } from 'hooks/useDocListData'
import DocumentUploadError from 'images/documentUploadError'
import DocumentUploadErrorRetry from 'images/documentUploadErrorRetry'
import { useNotificationStore } from 'store/useNotificationStore'

const ErrorCard = ({ id, selectFile = () => {}, onKeyDownHandler = () => {}, ...props }) => {
    const documentName = getDocName(props)
    const { title, content } = useNotificationStore((state) => state)
    const spinnerRef = useRef(null)

    useEffect(() => {
        spinnerRef.current.focus()
    }, [])

    return (
        <Card
            tabIndex={0}
            data-testid={id}
            role="label"
            ref={spinnerRef}
            sx={{
                border: (theme) => `1.5px solid ${theme.palette.error.main}`,
                justifyContent: 'flex-end',
                borderRadius: 4,
                px: 4,
                py: 3,
                boxShadow: '0'
            }}
            onClick={selectFile}
            onKeyDown={onKeyDownHandler}
        >
            <Box
                sx={{
                    display: 'grid'
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridAutoFlow: 'column',
                        gap: 0,
                        lineHeight: 0
                    }}
                >
                    <CardContent
                        sx={{
                            alignItems: 'flex-start'
                        }}
                    >
                        <Box
                            role="img"
                            aria-label="error icon"
                            data-testid="action-error"
                            sx={{
                                color: 'primary.main',
                                pt: 2,
                                textAlign: 'right'
                            }}
                        >
                            <DocumentUploadError />
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                lineHeight: 0
                            }}
                        >
                            <CardTitle
                                sx={{
                                    typography: 'boldBody2',
                                    letterSpacing: 0,
                                    paddingBottom: 1,
                                    color: 'common.error.darker'
                                }}
                                data-testid="document-name"
                            >
                                {documentName}
                            </CardTitle>
                            <Box>
                                <Typography
                                    component="span"
                                    data-testid="document-error-status"
                                    sx={{
                                        typography: 'regularCaption',
                                        letterSpacing: 0,
                                        backgroundColor: '#BF152C',
                                        padding: 1,
                                        borderRadius: 1,
                                        color: 'common.white.main'
                                    }}
                                >
                                    {title}
                                </Typography>
                            </Box>

                            <Typography
                                component="span"
                                data-testid="document-error-content"
                                sx={{
                                    typography: 'regularBody3',
                                    letterSpacing: 0,
                                    paddingTop: 1,
                                    borderRadius: 1,
                                    color: 'common.error.darker'
                                }}
                            >
                                {content}
                            </Typography>
                        </Box>
                    </CardContent>
                    <Box
                        role="img"
                        aria-label="reupload icon"
                        data-testid="action-reupload"
                        sx={{
                            color: 'primary.main',
                            textAlign: 'right',
                            paddingLeft: 1
                        }}
                    >
                        <DocumentUploadErrorRetry />
                    </Box>
                </Box>
            </Box>
        </Card>
    )
}

ErrorCard.propTypes = {
    id: PropTypes.number,
    selectFile: PropTypes.func,
    onKeyDownHandler: PropTypes.func
}

export default ErrorCard
